import { useEffect, useState } from 'react'
import type { Patient } from '@medplum/fhirtypes'
import { useClient } from '@/hooks/useClient'

export type FacilitySuggestion = {
  name: string
  address?: string
  street?: string
  city?: string
  state?: string
  zip?: string
  phone?: string
}

/**
 * Places the patient has been (their record Locations), via the middleware
 * `recordLocationsGet` oRPC procedure. Used for "been here" indicators and
 * name suggestions in the facility picker / add-facility form.
 */
export function useRecordLocationSuggestions(patient: Patient) {
  const client = useClient()
  const [suggestions, setSuggestions] = useState<FacilitySuggestion[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!patient.id) {
      setSuggestions([])
      setLoading(false)
      return
    }
    let cancelled = false
    setLoading(true)
    client
      .recordLocationsGet({ patientId: patient.id })
      .then(({ locations }) => {
        if (!cancelled) setSuggestions(locations)
      })
      .catch(() => {
        if (!cancelled) setSuggestions([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [client, patient.id])

  return { suggestions, loading }
}
